<template>
    <div id="cesiumContainer">
       <map-compass :sceneBool='sceneBool'></map-compass>
    </div>
</template>
<script>
import { Viewer, Ellipsoid, FeatureDetection, UrlTemplateImageryProvider, HeadingPitchRange, ScreenSpaceEventHandler, ScreenSpaceEventType,
   CameraEventType, Math as CesiumMath, Cartesian3, Color as CesiumColor, PolylineOutlineMaterialProperty, PostProcessStageLibrary, CustomDataSource } from "cesium/Cesium";
import mapCompass from "@/components/mapControlTool/mapCompass.vue";
import videoData from "./data/video";
import "cesium/Widgets/widgets.css";
import MyBridge from "./plugins/MyBridge";
import BuildingModel from "./plugins/BuildingModel";
import PolygonLayer from "./plugins/PolygonLayer";
import LabelLayer from "./plugins/LabelLayer";
import CameraUtil from "./plugins/CameraUtil";
import PictureLayer from "./plugins/PictureLayer";
import axios from "axios";

export default {
    name: "cesiumContainer",
    data() {
      return {
        sceneBool: false,
        pointsLayers: {}
      };
    },
    created() {
      let urlString = window.location.href;
      let subIndex = urlString.lastIndexOf("html");
      let urlStringSub = urlString.substring(0, subIndex + 1);
      subIndex = urlStringSub.lastIndexOf("/");
      this.highLightBuildingSource = new CustomDataSource("highLightBuildingSource");
      // 获取项目根路径
      this.rootUrl = urlStringSub.substring(0, subIndex + 1);
      // 实例化与父页面通信桥梁
      this.myBridge = new MyBridge(this.myBridgeListener);
    },
    beforeDestroy() {
      this.myBridge.destory();
    },
    mounted () {
      this.$nextTick(() => {
              this.cesiumInit();
              window.viewer.dataSources.add(this.highLightBuildingSource);
              this.openAntiAliasing();
              this.initClick();
              if (window.$config.initView) {
                let position = window.$config.initView.position;
                    window.viewer.camera.setView({
                       destination: Cartesian3.fromDegrees(position[0], position[1], position[2]),
                       orientation: {
                              heading: CesiumMath.toRadians(window.$config.initView.heading),
                              pitch: -CesiumMath.toRadians(window.$config.initView.pitch)
                          }
                    });
              }
              this.initHighLight();
              this.sceneBool = true;
              if (window.$config.mode === "config") {
                 this.addModel();
                 this.addLable();
                 this.addConfigPOILayer();
                 this.addPolygon();
              }
              // 获取相机视角
              let cameraUtil = new CameraUtil();
              window.getCamera = function() {
                return cameraUtil.getCameraView(window.viewer);
              };
      });
    },
    components: {
      mapCompass
    },
    methods: {
    myBridgeListener(data) {
      if (data) {
        switch (data.action) {
          case "changeModelColor":
            this.model.setColor(data.params.propertyName, data.params.colors);
            break;
          case "addLayer":
            this.addLayer(data);
            break;
          case "removeLayer":
          this.removeLayer(data);
          break;
          case "showLayer":
            this.showLayer(data.params.name, data.params.show);
            break;
        };
      }
    },
    addLayer(data) {
      if (this.pointsLayers[data.params.name]) {
        window.viewer.dataSources.remove(this.pointsLayers[data.params.name].source);
      }
      this.pointsLayers[data.params.name] = new PictureLayer(data.params.data, { scale: data.params.imageScale, imageUrl: data.params.imageUrl, layerName: data.params.name });
      window.viewer.dataSources.add(this.pointsLayers[data.params.name].source);
    },
    addConfigLayer(data) {
      if (this.pointsLayers[data.name]) {
        window.viewer.dataSources.remove(this.pointsLayers[data.name].source);
      }
      this.pointsLayers[data.name] = new PictureLayer(data.data, { scale: data.imageScale, imageUrl: data.imageUrl, layerName: data.name });
      this.pointsLayers[data.name].source.show = data.defaultShow;
      window.viewer.dataSources.add(this.pointsLayers[data.name].source);
    },
    showLayer(layerName, bool) {
      if (this.pointsLayers[layerName]) {
              this.pointsLayers[layerName].source.show = bool;
      }
    },
    removeLayer(data) {
      if (this.pointsLayers[data.params.name]) {
        window.viewer.dataSources.remove(this.pointsLayers[data.params.name].source);
      }
      delete this.pointsLayers[data.params.name];
    },
    addLable() {
      if (window.$config.label) {
          axios.get(this.rootUrl + "config/data/" + window.$config.label.data).then(response => {
             // 计算图片路径
             window.$config.label.styles.forEach(s => {
               s.iconUrl = this.rootUrl + "config/imagesIcon/" + s.iconUrl;
             });
            this.labelLayer = new LabelLayer(response.data, {
                          propertyName: window.$config.label.propertyName,
                          styles: window.$config.label.styles });
            window.viewer.dataSources.add(this.labelLayer.source);
          }, response => {
              console.error("注记数据加载出错,请检查数据格式或配置是否正确！");
          });
      }
    },
    // 添加模型
    addModel() {
      if (window.$config.model) {
          axios.get(this.rootUrl + "config/data/" + window.$config.model.data).then(response => {
            this.model = new BuildingModel(response.data, {
                                    propertyName: window.$config.model.propertyName,
                                    colors: window.$config.model.colors });
            window.viewer.dataSources.add(this.model.source);
            if (!window.$config.initView) {
               window.viewer.flyTo(this.model.source, { duration: 1.5, offset: new HeadingPitchRange(CesiumMath.toRadians(0), -CesiumMath.toRadians(60), 600) });
            }
          }, response => {
              console.error("模型数据加载出错,请检查数据格式或配置是否正确！");
          });
      }
    },
    addPolygon() {
      if (window.$config.polygon) {
          axios.get(this.rootUrl + "config/data/" + window.$config.polygon.data).then(response => {
                     this.polygonLayer = new PolygonLayer(response.data, {
                                    propertyName: window.$config.polygon.propertyName,
                                    styles: window.$config.polygon.styles });
                     window.viewer.dataSources.add(this.polygonLayer.source);
          }, response => {
              console.error("面数据加载出错,请检查数据格式或配置是否正确！");
          });
      }
    },
    addConfigPOILayer() {
      if (window.$config.poi) {
        window.$config.poi.keys.forEach(key => {
           axios.get(this.rootUrl + "config/data/" + window.$config.poi.data[key].data).then(response => {
              let params = {
                name: key,
                data: response.data,
                imageUrl: this.rootUrl + "config/imagesIcon/" + window.$config.poi.data[key].style.imageUrl,
                imageScale: window.$config.poi.data[key].style.scale,
                defaultShow: window.$config.poi.data[key].defaultShow

              };
              this.addConfigLayer(params);
          }, response => {
              console.error("POI数据加载出错,请检查数据格式或配置是否正确！");
          });
        });
      }
    },
    addVideo() {
        this.videoLayer = new PictureLayer(videoData, { scale: 0.6, imageUrl: require("./img/video.png"), layerName: "videoLayer" });
        window.viewer.dataSources.add(this.videoLayer.source);
    },
    // 高亮选择实体点
    initHighLight() {
      this.highLight = PostProcessStageLibrary.createEdgeDetectionStage();
      this.highLight.uniforms.color = new CesiumColor(0, 1, 1, 1);
      this.highLight.uniforms.length = 0.1;
      this.highLight.selected = [];
      window.viewer.scene.postProcessStages.add(PostProcessStageLibrary.createSilhouetteStage([this.highLight]));
    },
      showPopupClick(data) {
        if (data) {
          if (data.id.properties && data.id.properties.geometryType23) {
                if (data.id.properties.geometryType23.getValue() === "Point") {
                  this.pointClickHandle(data);
                } else {
                    this.clearHighLightBuilding();
                    this.clearClickPoint();
                }
           } else if (data.id.properties && data.id.properties.monitor23Buildinginner) {
                if (data.id.properties.monitor23Buildinginner.getValue() === "Building") {
                  this.buildingClickHandle(data);
                } else {
                    this.clearHighLightBuilding();
                }
            } else {
                this.clearHighLightBuilding();
                this.clearClickPoint();
            }
        } else {
          this.clearClickPoint();
        }
      },
    // 取消点选中
    clearClickPoint() {
      this.highLight.selected = [];
    },
    calculateHeight(cartesian3, height) {
       let curPosition = Ellipsoid.WGS84.cartesianToCartographic(cartesian3); // 地理坐标
       curPosition.height = curPosition.height + height; // 地理坐标加对应距离即为高度
       return Ellipsoid.WGS84.cartographicToCartesian(curPosition); // 返回计算后的相机位置
    },
    clearHighLightBuilding() {
      this.highLightBuildingSource.entities.removeAll();
    },
    highLightBuilding(positions, height) {
      let heightPositions = [];
      let material = new PolylineOutlineMaterialProperty({
                  color: new CesiumColor(0, 1, 1),
                  outlineWidth: 0
              });
      positions.forEach((e, i) => {
            let eHeight = this.calculateHeight(e, height);
            if (i < positions.length) {
                this.highLightBuildingSource.entities.add({
                    polyline: {
                      positions: [e, eHeight],
                      width: 2,
                      material: material,
                      zIndex: 10
                  }
              });
            }
            heightPositions.push(eHeight);
        });
        this.highLightBuildingSource.entities.add({
                polyline: {
                  positions: positions,
                  width: 2,
                  material: material,
                  zIndex: 10
              }
          });
          this.highLightBuildingSource.entities.add({
                polyline: {
                  positions: heightPositions,
                  width: 2,
                  material: material,
                  zIndex: 10
              }
          });
    },
    buildingClickHandle(data) {
      let clickData = {};
      let layerName = "BuildingModel";
      clickData[layerName] = {};
      data.id.properties.propertyNames.forEach(name => {
        let value = data.id.properties[name].getValue();
        clickData[layerName][name] = value;
      });
      console.log("monitor23日志：", { type: "buildingClick", data: clickData });
      this.myBridge.invoke({ type: "buildingClick", data: clickData }, "monitor23");
      this.clearHighLightBuilding();
      this.highLightBuilding(data.id.polygon.hierarchy.getValue().positions, data.id.polygon.extrudedHeight.getValue());
    },
    pointClickHandle(data) {
      let clickData = {};
      let layerName = data.id.properties.layerName23.getValue();
      clickData[layerName] = {};
      data.id.properties.propertyNames.forEach(name => {
        let value = data.id.properties[name].getValue();
        clickData[layerName][name] = value;
      });
      console.log("monitor23日志：", { type: "mapClick", data: clickData });
      this.myBridge.invoke({ type: "mapClick", data: clickData }, "monitor23");
      if (data.primitive === this.highLight.selected[0]) {

      } else {
        this.highLight.selected = [data.primitive];
      }
    },
    initClick() {
        let handler = new ScreenSpaceEventHandler(window.viewer.scene.canvas);
        handler.setInputAction((click) => {
          let pick = window.viewer.scene.pick(click.position);
          this.showPopupClick(pick);
        }, ScreenSpaceEventType.LEFT_CLICK);
    },
    // 添加高度区分图层
      gaodeImageLayer() {
        window.viewer.imageryLayers.removeAll();
        let tdtBaseMap = new UrlTemplateImageryProvider({
                  maximumLevel: 17,
                 url: "http://webst02.is.autonavi.com/appmaptile?style=6&x={x}&y={y}&z={z}"
                      });
        // let tdtAnnoMap = new UrlTemplateImageryProvider({
        //          url: "http://webst01.is.autonavi.com/appmaptile?style=8&x={x}&y={y}&z={z}"
        //               });
        window.viewer.imageryLayers.addImageryProvider(tdtBaseMap);
       // window.viewer.imageryLayers.addImageryProvider(tdtAnnoMap);
      },
      // 开启抗锯齿，模型更清晰
      openAntiAliasing() {
        if (FeatureDetection.supportsImageRenderingPixelated()) { // 判断是否支持图像渲染像素化处理
                window.viewer.resolutionScale = window.devicePixelRatio;
              }
          window.viewer.scene.fxaa = true;
          window.viewer.scene.postProcessStages.fxaa.enabled = true;
      },
      cesiumInit() {
        window.viewer = new Viewer("cesiumContainer", {
          animation: false, // 是否显示动画控件
          baseLayerPicker: false, // 是否显示图层选择控件
          geocoder: false, // 是否显示地名查找控件
          timeline: false, // 是否显示时间线控件
          fullscreenButton: false, // 全屏按钮
          sceneModePicker: false, // 是否显示投影方式控件
          selectionIndicator: false,
          navigationHelpButton: false, // 是否显示帮助信息控件
          infoBox: false // 是否显示点击要素之后显示的信息
          // imageryProvider: new UrlTemplateImageryProvider({
          //         maximumLevel: 18,
          //        url: "http://img2.xs.cdnyes.com/mt1/?lyrs=s@817&hl=zh-CN&callb=brlg7y&x={x}&y={y}&z={z}"
          //             })

        });
        this.gaodeImageLayer();
          window.viewer.scene.globe.depthTestAgainstTerrain = false;
          // 修改cesium为：左键移动，右键旋转，滚轮缩放交互
          let screenSpaceCameraController = window.viewer.scene.screenSpaceCameraController;
          screenSpaceCameraController.zoomEventTypes = [CameraEventType.WHEEL, CameraEventType.PINCH];
          screenSpaceCameraController.tiltEventTypes = [CameraEventType.RIGHT_DRAG];
          // 去除cesium logo
          window.viewer.bottomContainer.style.display = "none";
          // window.viewer.scene.screenSpaceCameraController.minimumZoomDistance = 2000;
         window.viewer.scene.screenSpaceCameraController.maximumZoomDistance = 3500;
         // window.viewer.scene.skyBox.show = false;
         window.viewer.scene.sun.show = false;
         window.viewer.scene.moon.show = false;
         // window.viewer.scene.skyAtmosphere.show = false;
         // window.viewer.scene.globe.show = false;
         // window.viewer.scene.backgroundColor = CesiumColor.WHITE;
         // 设置home键执行
         window.viewer.homeButton.viewModel.command.beforeExecute.addEventListener((e) => {
                    e.cancel = true;
                if (window.$config.initView) {
                    let position = window.$config.initView.position;
                    window.viewer.camera.flyTo({
                       destination: Cartesian3.fromDegrees(position[0], position[1], position[2]),
                       orientation: {
                              heading: CesiumMath.toRadians(window.$config.initView.heading),
                              pitch: -CesiumMath.toRadians(window.$config.initView.pitch)
                          }
                    });
                  } else {
                    window.viewer.flyTo(this.model.source, { offset: new HeadingPitchRange(CesiumMath.toRadians(0), -CesiumMath.toRadians(60), 600) });
                  }
              });
      }
    }
 };
</script>
<style scoped>
#cesiumContainer {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    overflow: hidden;
}
</style>
